export const getURLTokenHashFromQuery = () => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('token')
}

export const removeURLTokenHashFromQuery = () => {
  window.history.replaceState({}, document.title, window.location.pathname)
}
